import { ca } from '@cian/analytics';
import { getAnalyticsOfferStatus } from '../../../../utils';

export const trackServiceChange = (serviceId: string, isNewOffer: boolean) => {
  ca('eventSite', {
    name: 'oldevent',
    category: getAnalyticsOfferStatus(isNewOffer),
    action: 'publish_terms_block_autochange_vas',
    label: serviceId,
  });
};
